<template>
  <v-row>
    <v-col cols="12"> 
      <v-sheet 
        outlined
        >
        <v-row class="pa-4">
          <v-col
            class="d-flex"
            cols="12"
          >
            <v-select
              :loading="loading"
              :items="editions"
              label="Edición"
              v-model="edition_id"
              name="editions"
              :item-text="'name'"
              :item-value="'id'"
              outlined
              @change="handleSelectChange"
            ></v-select>
          </v-col>

          <v-col cols="12" class="pa-6"> 
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field> 
          </v-col> 

          <v-col 
            cols="12">
            <v-data-table
              :headers="headers"
              :items="entrepreneurships"
              :search="search"
              :items-per-page="50"
                  :footer-props="{
                    'items-per-page-options': [30, 40, 50, 100, 200],
                    'items-per-page-text':'Filas por página',
                  }"
              mobile="true"
            >
              <template v-slot:item.published="{ item }">
                {{ (item.published_by_admin==0)?'Bloqueado':((item.published)?'Publicado':'No Publicado') }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn
                  class="mx-2"
                  fab
                  dark
                  x-small
                  color="primary"
                  :to="{ name: 'showEntrepreneurshipListAdmin', params: { entrepreneurship_id: item.id } }"
                >
                  <v-icon dark small>
                    mdi-eye
                  </v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-col>

        </v-row>
      </v-sheet>
    </v-col>

    <v-dialog
      v-model="loading_entrepreneurships"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    
  </v-row>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'EntrepreneurshipsList',
    data: () => ({
      loading:true,
      loading_entrepreneurships:true,
      
      search: '',

      dialog:false,
      name:'',

      editions:[],
      edition_id:null,

      entrepreneurships:[], 

      headers: [
        {
          text: '# ID',
          align: 'center',
          filterable: true,
          value: 'id',
          width:'5%'
        },
        {
          text: 'Emprendimiento',
          align: 'start',
          filterable: true,
          value: 'title',
          width:'30%'
        },
        {
          text: 'Stand',
          align: 'center',
          filterable: true,
          value: 'published',
          width:'15%'
        },
        {
          text: 'Visualizaciones',
          align: 'center',
          filterable: true,
          value: 'views',
          width:'15%'
        },
        {
          text: 'Likes',
          align: 'center',
          filterable: true,
          value: 'likes',
          width:'10%'
        },
        {
          text: 'Tipo de postulación',
          align: 'start',
          filterable: true,
          value: 'type_postulations.name',
          width:'20%'
        },
        { 
          text: 'Acciones',
          align: 'center',
          filterable: false,
          value: 'actions',
          width:'10%'
        },
      ]
    }),

    methods:{
      createdView()
      {
        this.tabs = this.$store.state.currentTab
        this.edition_id = this.$store.state.currentEdition
      },

      async getEditions()
      {
        await axios.get('admin/editions').then(response =>{
          this.editions = response.data
          
          if(this.editions && !this.edition_id){
            this.edition_id = this.editions[0].id
          }
          this.loading=false
        }).catch(error => {
          console.log(error);
          this.loading=false
        })
      },

      async getEntrepreneurships()
      {
        if(this.edition_id!=null){
          this.loading_entrepreneurships=true
          await axios.get('admin/edition/'+this.edition_id+'/entrepreneurships').then(response =>{
            this.entrepreneurships = response.data.data.entrepreneurships
            this.loading_entrepreneurships=false
            this.show=true
          }).catch(error => {
            console.log(error);
            this.loading=false
          })
        }
      },

      handleTabChange(tab)
      {
        this.$store.state.currentTab = tab
      },

      handleSelectChange(edition_id)
      {
        this.$store.state.currentEdition = edition_id
        this.getEntrepreneurships()
      },
    },

    created(){
      Promise.all([
        this.createdView(),
        this.getEditions()
      ]).then(() => {
        this.getEntrepreneurships()
      }).catch((error) => {
        console.log(error)
      });
    },
  }
</script>